import * as React from 'react';
import { Link } from 'react-router';
import { commonStingManagerManager } from '../../api/commonStingManagerManager';

import EventItem from '../../api/eventItemEntity';

interface IProps {
    eventItems: EventItem[];
    fetchEventItems(): void;
}

export class LatestEventsBlock extends React.Component<IProps,{}> {
  public componentDidMount() {
    this.props.fetchEventItems();
  }

  public render() {
    return (
            <div className="row">
                {this.props.eventItems.slice(0, 3).map(LatestEventItem)}
            </div>
    );
  }
};

const LatestEventItem = (eventItem: EventItem) => {
  return (
    <div className="col-md-4">
        <div className="box news">
            <Link to={`/tapahtumat${eventItem.id}`} className="box-inner-wrap" tabIndex={-1}>
                <div className="box-image-wrap"><img alt="" src={eventItem.eventImage} /></div>
                <div className="box-content">
                    <span className="date">{commonStingManagerManager.formatDateToFiCulture(eventItem.eventDate)}</span>
                    <span className="organiser">{eventItem.eventPlace.title}</span>
                    <h3>{eventItem.title}</h3>
                </div>
            </Link>
        </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/latestEventsListBlock/latestEventsListBlock.tsx